import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const HeaderFlex = styled(Flex)`
  margin: 20px 0;
`

export const NameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin: 0 6px;
`
export const DetailsDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const NameInfoDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
`
export const InterviewTime = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
  margin: 0 5px;
`
export const InterviewInfo = styled.div`
  padding: 15px;
  width: 100%;
  height: 100%;
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
`
export const RightFlex = styled(Flex)`
  gap: 10px;
  margin: 8px 0 0 0;
  flex-wrap: wrap;
`
export const LeftFlex = styled(Flex)`
  gap: 10px;
  padding-right: 10px;
  border-right: ${props => props?.noBoader && `1px solid ${COLORS.GREY_T_90}`};
`
export const ContentDiv = styled.div`
  font-style: normal;
  text-wrap: inherit !important;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  flex: 0.8;
`
export const CommentDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_50_2};
  flex-wrap: wrap;
`

export const DetailsNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_50_2};
  flex: 0.2;
  white-space: nowrap;
  text-transform: capitalize;
`
export const UploadFlex = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_60};
  padding-bottom: 15px;
  margin-bottom: 10px;
`
export const InterviewFlex = styled(Flex)``
export const StatusDiv = styled.div`
  width: 77px;
  height: 23px;
  background: #eff8f4;
  border: 1px solid #bee1d4;
  border-radius: 6px;
  padding: 4px 6px;
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: #5db594;
`
export const InterviewerDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
  margin: 0 6px 0 0;
`
export const StrenthDiv = styled.div`
  width: 45%;
  border-right: 1px solid ${COLORS.GREY_T_60};
  margin-right: 15px;
`
export const WeeknessDiv = styled.div`
  width: 60%;
`
export const CommonFlex = styled(Flex)`
  margin: 15px 0;
`
export const TagsDiv = styled.div`
  background: ${COLORS.GREY_T_95};
  border-radius: 6px;
  padding: 3px 8px;
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_40};
`
export const TagsFlex = styled(Flex)`
  gap: 6px;
  margin: 10px 5px 10px 0;
`
export const Padding = styled(Flex)`
  padding: 1px;
`
